import React, { Component } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { Alert } from '@material-ui/lab';

class Errorbar extends Component { 

    
    render(){
        return(
            <div>
                <Snackbar
                    anchorOrigin={{vertical:"top", horizontal:"center"}}
                    open={this.props.open}
                    onClose={this.props.handleClose}
                    key="errorbar"
                    style={{width:"80%"}}
                >
                    <Alert onClose={this.props.handleClose} severity="error">
                        <text style={{fontSize:"30px"}}>{this.props.message}</text>
                    </Alert>
                </Snackbar>
            </div>
        )
    }
}

export default Errorbar;